import { appFormUtil } from 'modules/common';
import React from 'react';
import * as ds from './dataService';
import { useParams } from 'react-router-dom';
import { StyledDropDown } from 'modules/components/layer01';
import _ from 'lodash';


export type SelectMilestoneFieldProps<T extends object> = appFormUtil.SelectFieldProps<T> & {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object>(props: SelectMilestoneFieldProps<T>) => {
  const params = useParams();
  const { data } = ds.useQuery(params.projectId ?? '');
  const initialOnChange = props.form.genFieldProps(props.fieldName).onChange;



  return (
    <StyledDropDown.FC
      {...props.form.genFieldProps(props.fieldName)}
      onChange={(e) => {
        if (e.target.value !== '') {
          _.mapKeys(props.form.formState, (node, key) => {
            if (key === 'connectedToMilestone') {
              props.form.dispatch({
                type: 'UPDATE',
                payload: {
                  property: key as keyof T,
                  value: true as T[keyof T]
                }
              });
            }
          });
        } else if (e.target.value === '') {
          _.mapKeys(props.form.formState, (node, key) => {
            if (key === 'connectedToMilestone') {
              props.form.dispatch({
                type: 'UPDATE',
                payload: {
                  property: key as keyof T,
                  value: false as T[keyof T]
                }
              });
            }
          });
        }

        initialOnChange(e);

      }}
      options={[
        ...data,
        {
          id: '', name: '', displayName: 'None'
        }
      ]}
    />
  );
};
